import { Capacitor } from '@capacitor/core';

/**
 * שכבת הפלטפורמה: true כשהקוד רץ בתוך אפליקציית Capacitor (אנדרואיד/iOS).
 * בווב רגיל תמיד false — כל ההתנהגות של האתר נשארת כמו שהיא.
 */
export const isNative: boolean = Capacitor.isNativePlatform();

export const nativePlatform: 'android' | 'ios' | 'web' = Capacitor.getPlatform() as 'android' | 'ios' | 'web';
